import { render } from "./MoreDetailsRoster9Screen.vue?vue&type=template&id=60ed00ed&scoped=true"
import script from "./MoreDetailsRoster9Screen.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster9Screen.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster9Screen.vue?vue&type=style&index=0&id=60ed00ed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ed00ed"]])

export default __exports__